import { mapGetters } from 'vuex';
import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import sort from '@/common/utilities/sort';
import format from '@/common/utilities/format';
import { getPathByFilter } from '../../../../widget/spec/filterhelper';

export default {
    name: 'propertyNearbyHouse',
    inject: ['$eventBus'],
    props: {
        max: {
            type: Number,
            default: 30,
        },
        sort: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: 'Nearby Homes',
        },
        carousalType: {
            type: String,
            default: "",
            required: false
        },
        theme: {
            type: String,
            default: ""
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        mvtDropdownList,
        mvtNearby,
    },
    data() {
        return {
            componentMounted: false,
            //avgNearbyHomePrice: '',
            sortBy: 'similar_desc',
            sortByList: [
                {
                    text: this.molang('dpp.propertyNearby.distance'),
                    labelText: this.theme === 'newDpp' ? `<i class="icon-sort"></i> <span>Sort by:</span><span>${this.molang('dpp.propertyNearby.distance')}</span>` : `<i class="icon-sort-down"></i> ${this.molang('dpp.propertyNearby.distance')}`,
                    value: 'distance_asc',
                },

                {
                    text: this.molang('dpp.propertyNearby.similar'),
                    labelText: this.theme === 'newDpp' ? `<i class="icon-sort"></i> <span>Sort by:</span><span>${this.molang('dpp.propertyNearby.similar')}</span>` : `<i class="icon-sort-down"></i> ${this.molang('dpp.propertyNearby.similar')}`,
                    value: 'similar_desc',
                },

                {
                    text: this.molang('dpp.propertyNearby.listDate'),
                    labelText: this.theme === 'newDpp' ? `<i class="icon-sort"></i> <span>Sort by:</span><span>${this.molang('dpp.propertyNearby.listDate')}</span>` : `<i class="icon-sort-down"></i> ${this.molang('dpp.propertyNearby.listDate')}`,
                    value: 'dom_asc',
                },

                {
                    text: this.molang('dpp.propertyNearby.priceHigh'),
                    labelText: this.theme === 'newDpp' ? `<i class="icon-sort"></i> <span>Sort by:</span><span>${this.molang('dpp.propertyNearby.priceHigh')}</span>` : `<i class="icon-sort-down"></i> ${this.molang('dpp.propertyNearby.priceHigh')}`,
                    value: 'price_desc',
                },

                {
                    text: this.molang('dpp.propertyNearby.priceLow'),
                    labelText: this.theme === 'newDpp' ? `<i class="icon-sort"></i> <span>Sort by:</span><span>${this.molang('dpp.propertyNearby.priceLow')}</span>` : `<i class="icon-sort-down"></i> ${this.molang('dpp.propertyNearby.priceLow')}`,
                    value: 'price_asc',
                },

                {
                    text: this.molang('dpp.propertyNearby.sqftBig'),
                    labelText: this.theme === 'newDpp' ? `<i class="icon-sort"></i> <span>Sort by:</span><span>${this.molang('dpp.propertyNearby.sqftBig')}</span>` : `<i class="icon-sort-down"></i> ${this.molang('dpp.propertyNearby.sqftBig')}`,
                    value: 'sqft_desc',
                },

                {
                    text: this.molang('dpp.propertyNearby.sqftSmall'),
                    labelText: this.theme === 'newDpp' ? `<i class="icon-sort"></i> <span>Sort by:</span><span>${this.molang('dpp.propertyNearby.sqftSmall')}</span>` : `<i class="icon-sort-down"></i> ${this.molang('dpp.propertyNearby.sqftSmall')}`,
                    value: 'sqft_asc',
                },

                {
                    text: 'Best Value',
                    labelText: this.theme === 'newDpp' ? '<i class="icon-sort"></i> <span>Sort by:</span><span>Best Value</span>' : '<i class="icon-sort-down"></i> Best Value',
                    value: 'pricepersqft_asc',
                },
            ],
            sortedNearbyHome: [],
        };
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        popMapView() {
            this.$eventBus.$emit('property-pop-map', { popMapTypeId: 0, popStreetView: false });
        },
        getMSPSort(filter = '') {
            return filter != 'similar_desc' ? `sortby-${filter.replace(/_/g, '-')}/` : '';
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getNearbyHome']),
        linkText() {
            if (this.dpp.isRentals) {
                if (this.dpp.geo.neighborhoodPath) {
                    return `${this.dpp.propertyTypeDisplay}s for rent in ${this.dpp.geo.neighborhood}`;
                }
                return `${this.dpp.propertyTypeDisplay}s for rent in ${this.dpp.geo.zipcode}`;
            }
            if (this.carousalType === 'best_value') {
                if (this.dpp.geo.neighborhoodPath) {
                    return `Homes for sale in ${this.dpp.geo.neighborhood}`;
                }
                return `Homes for sale in ${this.dpp.geo.zipcode}`;
            }
            return `Homes for sale in ${this.dpp.geo.city}, ${this.dpp.geo.state}`;
        },
        getMSPLink() {
            if (this.dpp.isRentals) {
                let filterPath = getPathByFilter({
                    propertyType: [this.dpp.propertyType],
                });
                if (this.dpp.geo.neighborhoodPath) {
                    return `${this.glb.appUrl}${this.dpp.geo.neighborhoodPath}${filterPath}`;
                }
                return `${this.glb.appUrl}${this.dpp.geo.zipcodePath}${filterPath}`;
            }
            if (this.carousalType === 'best_value') {
                if (this.dpp.geo.neighborhoodPath) {
                    return `${this.glb.appUrl}${this.dpp.geo.neighborhoodPath}`;
                }
                return `${this.glb.appUrl}${this.dpp.geo.zipcodePath}`;
            }
            return `${this.glb.appUrl}${this.dpp.geo.cityPath}`;
        },
        hidePricePreArea() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule && compliance[0].rule.indexOf('hidePricePreArea') >= 0;
        },
        getAvg() {
            var totallistprice = 0;
            var totalbeds = 0;
            var totalbath = 0;
            var totalarea = 0;
            var totalareaval = 0;
            var count = this.getNearbyHome.length;
            var count2 = this.getNearbyHome.length;
            var totalhoafee = 0;
            var totalyearBuilt = 0;
            var totallotSize = 0;

            for (var i = 0; i < this.getNearbyHome.length; i++) {
                if (this.getNearbyHome[i].hoafee == 0) {
                    count = count - 1;
                }
                if (this.getNearbyHome[i].yearBuilt == 0) {
                    count2 = count2 - 1;
                }
                totallistprice = totallistprice + this.getNearbyHome[i].price;
                totalbeds = totalbeds + this.getNearbyHome[i].bed;
                totalbath = totalbath + this.getNearbyHome[i].bath;
                totalarea = totalarea + this.getNearbyHome[i].area;
                totalareaval = totalareaval + this.getNearbyHome[i].pricePerArea;
                totalhoafee = totalhoafee + this.getNearbyHome[i].hoafee;
                totalyearBuilt = totalyearBuilt + this.getNearbyHome[i].yearBuilt;
                totallotSize = totallotSize + this.getNearbyHome[i].lotSize;
            }
            var avgBeds = totalbeds / this.getNearbyHome.length;
            var formatavgBeds = format.fixedThreeDigits(avgBeds);
            var avgNearbyHomePrice = totallistprice / this.getNearbyHome.length;
            var formatavgPrice = format.friendlyPrice(avgNearbyHomePrice);
            var avgBaths = totalbath / this.getNearbyHome.length;
            var formatavgBaths = format.fixedThreeDigits(avgBaths);
            var avgArea = totalarea / this.getNearbyHome.length;
            var formatavgArea = format.fixedThreeDigits(avgArea);
            var doubleformatavgArea = format.formatNumberByComma(formatavgArea);
            var avglotSize = totallotSize / this.getNearbyHome.length;
            var formatavglotSize = format.fixedThreeDigits(avglotSize);
            var doubleformatavglotSize = format.formatNumberByComma(formatavglotSize);
            var avgAreaval = totalareaval / this.getNearbyHome.length;
            var formatavgAreaval = format.fixedThreeDigits(avgAreaval);
            var avgHoafee = totalhoafee / count;
            var formatavgHoafee = format.fixedThreeDigits(avgHoafee);
            var avgyearBuilt = totalyearBuilt / count2;
            var formatavgYearBuilt = format.normalRound(avgyearBuilt);
            var areaUnit = this.dpp.areaUnit;
            var isRent = this.dpp.isRentals;
            var priceLabel = isRent ? 'Rent' : 'List';

            if (['Condominium', 'Multi-family', 'Mobile', 'House', 'Apartment'].includes(this.dpp.propertyTypeDisplay)) {
                var hometype = 'homes';
            } else {
                var hometype = 'land';
            }
            if (this.dpp.propertyTypeDisplay == 'Condominium') {
                var avg = `Nearby Condos average: $${formatavgPrice} ${priceLabel} Price, ${formatavgBeds} Beds, ${formatavgBaths} Baths, ${doubleformatavgArea} ${areaUnit}, $${formatavgAreaval}/${areaUnit} Value, $${formatavgHoafee} HOA`;
                !isRent && (avg += `, and ${formatavgYearBuilt} Year Built.`);
            } else {
                var avg = `Nearby homes average: $${formatavgPrice} ${priceLabel} Price, ${
                    hometype !== 'land' ? `${formatavgBeds} Beds, ${formatavgBaths} Baths, ` : ''
                } ${doubleformatavgArea} ${areaUnit}`;
                if (!this.hidePricePreArea) {
                    avg += `, $${formatavgAreaval}/${areaUnit} Value`;
                }
                !isRent && (avg += `, ${doubleformatavglotSize} ${areaUnit} Lot Size${hometype !== 'land' ? `, and ${formatavgYearBuilt} Year Built.` : '.'}`);
            }
            return avg;
        },
    },
    watch: {
        sortBy(newVal, oldVal) {
            if (newVal != oldVal) {
                this.sortedNearbyHome = sort.sortProperty(this.sortBy, this.getNearbyHome, this.dpp).slice(0, this.max);
            }
        },
    },
    mounted(){
        this.componentMounted = true;
    },
    created() {
        if (this.sort) {
            this.sortBy = this.sort;
        }
        this.sortedNearbyHome = sort.sortProperty(this.sortBy, this.getNearbyHome, this.dpp).slice(0, this.max);
    },
};
